import { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

const useUserData = () => {
	const { instance, accounts } = useMsal();
	const [userData, setUserData] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		const getUserData = async () => {
			if (!accounts || accounts.length === 0) return;

			const account = accounts[0];
			const request = {
				scopes: ["User.Read"],
				account,
			};

			try {
				let response = await instance.acquireTokenSilent(request);

				if (!response) {
					throw new InteractionRequiredAuthError();
				}

				const graphResponse = await fetch(
					"https://graph.microsoft.com/v1.0/me",
					{
						headers: {
							Authorization: `Bearer ${response.accessToken}`,
						},
					}
				);

				const data = await graphResponse.json();
				setUserData({
					nom: data.surname,
					prenom: data.givenName,
					mail: data.mail,
					id: data.mail.replace("@epb-paris.fr", ""),
				});
			} catch (err) {
				if (err instanceof InteractionRequiredAuthError) {
					try {
						const response = await instance.acquireTokenPopup(
							request
						);
						const graphResponse = await fetch(
							"https://graph.microsoft.com/v1.0/me",
							{
								headers: {
									Authorization: `Bearer ${response.accessToken}`,
								},
							}
						);

						const data = await graphResponse.json();
						setUserData(data);
					} catch (popupError) {
						setError(popupError);
					}
				} else {
					setError(err);
				}
			} finally {
				setLoading(false);
			}
		};

		getUserData();
	}, [instance, accounts]);

	return { userData, loading, error };
};

export default useUserData;
